import * as R from 'ramda'

export default {
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
  methods: {
    async updateMemberships(orgId, teamId, isPrivateTeam) {
      if (teamId && (typeof isPrivateTeam === 'undefined' || isPrivateTeam)) {
        const teamMembers = this.$store.getters.teamMemberships(teamId)
        R.isEmpty(teamMembers) &&
          (await this.$store.dispatch('getTeamMemberships', {
            orgId,
            teamId
          }))
      } else {
        const orgMembers = this.$store.getters.orgMemberships(orgId)
        R.isEmpty(orgMembers) &&
          (await this.$store.dispatch('getOrgMemberships', {
            id: orgId
          }))
      }
    },
    async fetchOrgMemberships(orgId) {
      return this.$store.dispatch('getOrgMemberships', {
        id: orgId
      })
    },
    async fetchTeamMemberships(orgId, teamId) {
      return this.$store.dispatch('getTeamMemberships', {
        orgId,
        teamId
      })
    },
    async updateOrgMemberships(orgId) {
      const orgMembers = this.$store.getters.orgMemberships(orgId)
      if (R.isEmpty(orgMembers)) {
        return this.fetchOrgMemberships(orgId)
      }
      return orgMembers
    },
    updateTeamMemberships(orgId, teamId) {
      const teamMembers = this.$store.getters.teamMemberships(teamId)
      R.isEmpty(teamMembers) && this.fetchTeamMemberships(orgId, teamId)
    },
    getTeamById(teamId) {
      return this.$store.getters.teamById(teamId)
    },
    fetchUsersInScope(goal) {
      if (goal.type === 'team' && this.getTeamById(goal.teamId).isPrivate) {
        this.updateTeamMemberships(goal.organizationId, goal.teamId)
      } else {
        this.updateOrgMemberships(goal.organizationId)
      }
    },
    getUsersInScope(teamId, orgId) {
      let users
      const orgMemberships = this.$store.getters.orgMemberships(orgId)
      const isUserPartOfOrg = !!orgMemberships.find(x => x.user.id === this.user.id) // guests users of a team are not part of org
      if (teamId && (this.getTeamById(teamId).isPrivate || !isUserPartOfOrg)) {
        users = this.$store.getters.teamMemberships(teamId).map(x => x.user)
      } else if (orgId) {
        users = this.$store.getters.orgMemberships(orgId).map(x => x.user)
      }
      return users
    },
    getAndFetchUser(id) {
      const user = this.$store.getters.userById(id)
      if (!user) {
        this.$store.dispatch('getUser', { id })
      }
      return user
    }
  }
}
